'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var qwest = _interopRequireWildcard(require("qwest"));
var _is_js = _interopRequireDefault(require("is_js"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _TextEditor = _interopRequireDefault(require("Components/Forms/Elements/TextEditor"));
var _FileInput = _interopRequireDefault(require("Components/Forms/Elements/FileInput"));
var _Select = _interopRequireDefault(require("Components/Forms/Elements/Select"));
var _Switch = _interopRequireDefault(require("Components/Forms/Elements/Switch"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _handleChange = _interopRequireDefault(require("Components/Forms/Functions/handleChange"));
var _handleFileChange = _interopRequireDefault(require("Components/Forms/Functions/handleFileChange"));
var _getStateFromObject = _interopRequireDefault(require("Components/Forms/Functions/getStateFromObject"));
var _getFormData = _interopRequireDefault(require("Components/Forms/Functions/getFormData"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let app = window.app;
const category_options = [{
  value: "candidate",
  label: "Candidat"
}, {
  value: "company",
  label: "Recruteur"
}];
class BlogForm extends _react.Component {
  state = {
    status_messages: {},
    'blog[images]': [],
    'blog[documents]': [],
    'blog[visibility]': false
  };
  handleChange = _handleChange.default.bind(this);
  handleFileChange = _handleFileChange.default.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.type === 'update') {
      component.fetchBlog();
    }
  }
  fetchBlog = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/blog/get-all', {
      id: props.id || document.location.pathname.split('/contenu/liste-des-ressources/')[1],
      with_count: false
    }).then(function (xhr, response) {
      const images = (response.blogs[0]?.images || []).map(function (data) {
        let descriptor = {
          ...data,
          status: 'uploaded',
          filename: data?.url.slice(data.url.lastIndexOf('/') + 1)
        };
        return descriptor;
      });
      delete response.blogs[0].images;
      const documents = (response.blogs[0]?.documents || []).map(function (data) {
        let descriptor = {
          ...data,
          status: 'uploaded',
          filename: data?.url.slice(data?.url.lastIndexOf('/') + 1),
          pdf: true
        };
        return descriptor;
      });
      delete response.blogs[0].documents;
      const update = (0, _getStateFromObject.default)({
        data: response.blogs[0],
        model: 'blog'
      });
      component.setState({
        ...update,
        'blog[images]': images,
        'blog[documents]': documents,
        '__files-blog[images]': images,
        '__files-blog[documents]': documents,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
    component.setState({});
  };
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const blog = (0, _getFormData.default)({
      state: state,
      pattern: 'blog['
    });
    const url = props.type === 'update' ? '/blog/update' : '/blog/create';
    qwest.post(url, blog).then(function (xhr, response) {
      if (props.type === 'update') {
        component.fetchBlog();
      } else {
        component.clearForm();
        window.setTimeout(function () {
          app.navigateTo('/contenu/liste-des-ressources');
        }, 2000);
      }
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  clearForm = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const update = Object.keys(state).filter(key => key.startsWith('blog[')).reduce(function (update, key) {
      console.log(state[key], _is_js.default.string(state[key]));
      if (_is_js.default.string(state[key])) {
        update[key] = '';
      } else if (_is_js.default.array(state[key])) {
        update[key] = [];
      } else if (_is_js.default.json(state[key])) {
        update[key] = {};
      }
      return update;
    }, {});
    component.setState(update);
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let output = /*#__PURE__*/_react.default.createElement("form", {
      method: "POST",
      action: "/blog/create"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.validate
    }, props.type === 'update' ? 'Mettre à jour' : 'Créer cette ressource', loader)), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content",
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['blog[title]'],
      name: "blog[title]",
      type: "text",
      label: "Titre",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Switch.default, {
      onChange: component.handleChange,
      value: state['blog[visibility]'] === true,
      name: "blog[visibility]",
      "top-label": "Visibilit\xE9",
      "left-label": "Priv\xE9e",
      label: "Public",
      status: state.status_messages
    })), state['blog[visibility]'] === false ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleChange,
      value: state['blog[category]'],
      name: "blog[category]",
      type: "text",
      label: "Cat\xE9gorie",
      options: category_options,
      "default-value": category_options[0]?.value,
      status: state.status_messages
    })) : undefined, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["blog[description]"] || '',
      name: "blog[description]",
      label: "",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_FileInput.default, {
      accept: ".jpg,.jpeg,.png,.gif",
      onChange: component.handleFileChange,
      name: "blog[images]",
      data: state,
      status: state.status_messages,
      label: "Image"
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_FileInput.default, {
      accept: ".pdf",
      onChange: component.handleFileChange,
      name: "blog[documents]",
      data: state,
      status: state.status_messages,
      label: "Document"
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['blog[youtube_link]'],
      name: "blog[youtube_link]",
      type: "text",
      label: "Lien Youtube",
      status: state.status_messages
    })))), status, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.validate
    }, props.type === 'update' ? 'Mettre à jour' : 'Créer cette ressource', loader)));
    return output;
  }
}
exports.default = BlogForm;
